exports.version = "1.4.2"


//////////////////
// WEBPACK FOOTER
// ./~/apollo-client/version.js
// module id = 851
// module chunks = 0